import { render, staticRenderFns } from "./b-evaluation.vue?vue&type=template&id=7a5b0338&"
import script from "./b-evaluation.vue?vue&type=script&lang=js&"
export * from "./b-evaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports